(function () {
  const button = document.querySelector('[data-theme-back-to-top]');
  if (!button) return;

  let visibleOffset = 0;
  let ticking = false;

  const calculateVisibleOffset = function () {
    visibleOffset = (document.documentElement.scrollHeight * 20) / 100;
  };

  const updateButtonState = function () {
    const show = window.pageYOffset > visibleOffset;
    if (button.classList.contains('show') !== show) {
      button.classList.toggle('show', show);
      button.setAttribute('aria-hidden', String(!show));
    }
    ticking = false;
  };

  const onScroll = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateButtonState);
  };

  calculateVisibleOffset();
  updateButtonState();
  window.addEventListener('scroll', onScroll, { passive: true });

  if ('ResizeObserver' in window) {
    new ResizeObserver(calculateVisibleOffset).observe(document.body);
  } else {
    window.addEventListener('resize', calculateVisibleOffset, { passive: true });
  }

  button.addEventListener('click', function (event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();